/* MARVI OCEAN - Ocean Match reward.
 *
 * Nothing here mentions a discount until the quiz is finished and the visitor
 * asks for it. The reward is a surprise, not a bribe.
 *
 * DORMANT until WORKER_URL is set below. Until then OMReward.enabled() returns
 * false, no reward UI appears, and the quiz behaves exactly as it does today.
 *
 * TO SWITCH ON:
 *   1. Deploy the Cloudflare Worker (marvi-ocean-match-worker.js)
 *   2. Paste its URL into WORKER_URL below
 */
(function () {
  "use strict";

  /* PASTE YOUR WORKER URL HERE, e.g.
     var WORKER_URL = "https://marvi-ocean-match.yourname.workers.dev"; */
  var WORKER_URL = "";

  var OM = (window.OMReward = {});

  OM.enabled = function () {
    return !!WORKER_URL;
  };

  function storeKey(animal) {
    return "marvi-om-reward-" + animal;
  }

  /* A saved code is only good while it is still inside its window. */
  function readSaved(animal) {
    try {
      var raw = localStorage.getItem(storeKey(animal));
      if (!raw) return null;
      var saved = JSON.parse(raw);
      if (!saved.code || !saved.expiresAt) return null;
      if (new Date(saved.expiresAt).getTime() <= Date.now()) return null;
      return saved;
    } catch (e) {
      return null;
    }
  }

  function save(animal, data) {
    try {
      localStorage.setItem(storeKey(animal), JSON.stringify(data));
    } catch (e) {}
  }

  /* Ask the Worker to mint a code.
     Returns {code, expiresAt} or {error: 'limit'|'failed'|'disabled'}.
     Reuses a still-valid code rather than minting a second one, so a reload
     cannot be used to farm discounts. */
  OM.claim = function (animal) {
    if (!WORKER_URL) return Promise.resolve({ error: "disabled" });

    var existing = readSaved(animal);
    if (existing) return Promise.resolve(existing);

    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, 15000);

    return fetch(WORKER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ animal: animal }),
      signal: ctrl ? ctrl.signal : undefined,
    })
      .then(function (r) {
        clearTimeout(timer);
        if (r.status === 429) return { error: "limit" };
        if (!r.ok) return { error: "failed" };
        return r.json();
      })
      .then(function (d) {
        if (!d || d.error || !d.code) return { error: (d && d.error) || "failed" };
        save(animal, d);
        return d;
      })
      .catch(function () {
        clearTimeout(timer);
        return { error: "failed" };
      });
  };

  /* Human countdown: "3h 58m", "47m", "under a minute", or null once dead. */
  OM.remaining = function (expiresAt) {
    var ms = new Date(expiresAt).getTime() - Date.now();
    if (ms <= 0) return null;
    var mins = Math.floor(ms / 60000);
    var hrs = Math.floor(mins / 60);
    var rem = mins % 60;
    if (hrs > 0) return hrs + "h " + rem + "m";
    if (mins > 0) return mins + "m";
    return "under a minute";
  };
})();
